<form #formRef="ngForm" class="flex-content">

    <!-- HEADER -->
    <div style="float:left;">
        <h2 mat-dialog-title><span translate>{{DialogTitle}}</span></h2>
    </div>

    <!-- CONTENT -->
    <mat-dialog-content>


        <!-- Angular Material table definition -->
        <div style="display: flex;flex-direction: column; overflow: auto; ">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" style="width:100%;">
                <ng-container matColumnDef="selectAll">
                    <th mat-header-cell *matHeaderCellDef>
                        <tyl-checkbox [(checked)]="selectAll" id="chkselectAll" name="chkselectAll" (change)="selectAllGridItems(dataSource, $event)">
                        </tyl-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <tyl-checkbox [(checked)]="element.IsSelected" #Select (change)="selectItem(element, $event)" translate>
                        </tyl-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="TextField">
                    <th mat-header-cell *matHeaderCellDef>
                        <tyl-checkbox [(checked)]="selectAll" id="chkselectAll" name="chkselectAll" (change)="selectAllGridItems(dataSource, $event)">
                        </tyl-checkbox>
                        {{ ColumnHeader }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <tyl-checkbox [(checked)]="element.IsSelected" #Select (change)="selectItem(element, $event)" translate>
                        </tyl-checkbox>{{element.TextField}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="gridColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: gridColumns;"></tr>
            </table>
        </div>




    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions>
        <div class="flex-footer-left" style="align-items: center; width: 30%">
        </div>
        <div class="flex-footer-right" style="align-items: center; width: 70%">
            <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button style="float:right; color: black;" image="save.png" label="{{ OKButtonLabel }}" (clickEvent)="okClick()">
        </tyl-button>
            <tyl-button style="float:right; color: black;" image="cancel.png" label="Cancel"
                (clickEvent)="cancelClick()">
            </tyl-button>
        </div>
    </mat-dialog-actions>

</form>
